export enum RestrictedEditReasonType {
  ReadOnly = 'read-only',
  Teleport = 'teleport',
  FilesBeingCopied = 'files-being-copied',
}
